import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const AboutUs = () => {
     useEffect(() => {
        document.title = 'About Us -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>About Us </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>About Us  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p> Mary Matha CMI Academy, is owned by the Kottayam St. Joseph Province of the religious Congregation of the Carmelites of Mary Immaculate (CMI). Mary Matha Educational endeavors – invites you to the best satisfying edifice, offering everything you can imagine in the arena of education. This School comprises a family of teachers, parents and students under the able and efficient guidance of CMI fathers who have an impeccable track record of managing around 500 Educational institutions, in the most efficient way, throughout India.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default AboutUs
